export default __webpack_public_path__ + "static/media/AI-software-_-Engineering.8a05a114.png";